import { useEffect } from 'react'
import { AuthRouteImport } from './Imports'
const { useNavigate, Swal } = AuthRouteImport

export default function PageNotFound() {

    const navigate = useNavigate()

    useEffect(() => {
        Swal.fire({
            title: 'Oops...',
            text: '404 Page Not Found!',
            icon: 'error',
            confirmButtonColor: '#121136',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                navigate(-1)
            }
        })
    }, [])

    return (
        <></>
    )
}